import mime from "mime-types";

export class ExtensionValidator {
  private static customTypeMappings: { [key: string]: string | false } = {
    "video/avi": mime.lookup("avi")
  };

  public static getAcceptedTypes = (supportedExtensions: string[]): string[] =>
    supportedExtensions
      .map(mime.lookup)
      .filter((mimeType): mimeType is string => typeof mimeType === "string");

  public static normalizeFileType(type: string): string {
    return this.customTypeMappings[type] || type;
  }

  public static isSupported(
    { type: fileType, name }: File,
    supportedExtensions: string[]
  ): boolean {
    const type = this.normalizeFileType(fileType);

    if (
      type &&
      this.getAcceptedTypes(supportedExtensions).find((acceptedType) => acceptedType === type)
    ) {
      return true;
    }

    return !!supportedExtensions.find((ext) => name.endsWith(ext));
  }
}
